import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

import Code from './Code';

const SettingPage = () => {
  const [selected, setSelected] = useState(1);
  const user = useSelector((state) => state.user.userData);

  const settingList = [
    {
      id: 1,
      name: 'Code',
      icon: FormatListNumberedIcon,
    },
    // admin 항목 필요 시 추가 가능
  ];

  useEffect(() => {
    if (user?.isAdmin) {
      setSelected(2);
    } else {
      setSelected(1);
    }
  }, [user?.isAdmin]);

  return (
    <div>
      <Box
        sx={{
          margin: '4px 0 0 0',
          padding: '16px 8px 8px 16px',
          width: '100%',
          height: 120,
          backgroundColor: 'gray',
          opacity: 0.85,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          imageRendering: '-webkit-optimize-contrast',
          backfaceVisibility: 'hidden',
          transform: 'translateZ(0)',
        }}
      >
        <Typography variant="h3" color="white" sx={{ fontWeight: 800 }}>
          Setting
        </Typography>
      </Box>

      <Grid container>
        <Grid size={{ xs: 2, sm: 2, md: 2 }}>
          <Box sx={{ height: '100%', overflow: 'auto', p: 1 }}>
            <List>
              {settingList.map((list) => {
                if (!user?.isAdmin && list.id === 2) return null;

                return (
                  <ListItem key={list.id} disablePadding>
                    <ListItemButton selected={list.id === selected} onClick={() => setSelected(list.id)}>
                      <ListItemIcon>
                        <list.icon />
                      </ListItemIcon>
                      <ListItemText primary={list.name} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 10, sm: 10, md: 10 }}
          sx={{
            height: '100%',
            p: 2,
            borderLeft: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          {selected === 1 && <Code />}
        </Grid>
      </Grid>
    </div>
  );
};

export default SettingPage;
